import React from 'react';
import Image from 'next/image';
import styled, { keyframes } from 'styled-components';

import { StarsIcon2 } from '@/public/icons';
import americanExpress from '@/public/payments_icons/american_express_logo.svg.svg';
import discover from '@/public/payments_icons/discover_logo.svg.svg';
import mastercard from '@/public/payments_icons/mastercard_symbol.svg.svg';
import visa from '@/public/payments_icons/visa_inc_logo.svg.svg';

export const PaymentsMethodFrame = () => {
  return (
    <Wrapper>
      <Marquee>
        <Image src={americanExpress} alt="American Express" />
        <StarsIcon2 />
        <Image src={discover} alt="Discover" />
        <StarsIcon2 />
        <Image src={mastercard} alt="MasterCard" />
        <StarsIcon2 />
        <Image src={visa} alt="Visa" />
        <StarsIcon2 />
        <Image src={americanExpress} alt="American Express" />
        <StarsIcon2 />
        <Image src={discover} alt="Discover" />
        <StarsIcon2 />
        <Image src={mastercard} alt="MasterCard" />
        <StarsIcon2 />
        <Image src={visa} alt="Visa" />
        <StarsIcon2 />
      </Marquee>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: rgba(3, 7, 181, 1);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  padding: 16px 24px;
`;

const marquee = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }  
`;

const Marquee = styled.div`
  display: flex;
  align-items: center;
  gap: 64px;
  animation: ${marquee} 30s linear infinite;
  width: 200%;
`;
